
<template>
  <div class="content">
    <!-- search bar -->
    <div class="row my-3 justify-content-end">
      <div class="col-8"></div>
       <div class="col-auto">
        <!-- Header Search Input -->
        <a-input-search class="header-search" :class="searchLoading ? 'loading' : ''" placeholder="Search by BusinessUnit#, Location#, Operator#, City, State, FirstName, LastName…"
          @search="onSearch" :loading='searchLoading' v-model="searchQuery">
          <svg slot="prefix" width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4ZM2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 9.29583 13.5892 10.4957 12.8907 11.4765L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L11.4765 12.8907C10.4957 13.5892 9.29583 14 8 14C4.68629 14 2 11.3137 2 8Z"
              fill="#111827" />
          </svg>
        </a-input-search>
        <!-- / Header Search Input -->
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <card>
          <template slot="header">
            <div class="row justify-content-between align-items-between mx-3">

              <h5 class="card-title">Names</h5>
              
              <div>
                  <base-button class="btn btn-primary" @click="modalNames = true">Add</base-button>
	              <base-button class="btn btn-primary" @click="toggleView">Toggle View</base-button>
              </div>
              
              <modal :show.sync="modalNames">
                <template slot="header">
                  <h5 class="modal-title" id="exampleModalLabel">Add Name</h5>
                </template>
                <div>
                  <form @submit.prevent>
  <base-input label="Snake" type="text" placeholder="Enter Snake" v-model="nameToAdd.snake"></base-input>
                  </form>
                </div>
                <template slot="footer">
                  <base-button type="primary" @click="handleAddSubmitted()">Save</base-button>
                </template>
              </modal>
            </div>
          </template>


          <!-- Conditionally render the view based on the 'isTableView' flag -->
          <div v-if="isTableView">
            <!-- Render the existing Table View -->
            <a-table :columns="columns" :data-source="names" :row-key="record => record.NameId" :pagination="pagination"
              :loading="searchLoading" @change="onTableChange" :scroll="{ x: 'max-content' }">

              <template slot="nameId" slot-scope="dataIndex">
              	<router-link  :to="`/name/${dataIndex}`"><a >{{ dataIndex }}</a></router-link>
              </template>


             <template slot="lastModified" slot-scope="dataIndex">
              	{{ formatTime(dataIndex) }}
              </template>
              <template slot="createdOn" slot-scope="dataIndex">
              	{{ formatTime(dataIndex) }}
              </template>
              <template slot="blackOutStartDate" slot-scope="dataIndex">
              	{{ formatDate(dataIndex) }}
              </template>
            </a-table>
          </div>
          <div v-else>
            <!-- Render the Picture View  -->
            <NamePictureView :names="names" />
          </div>

        </card>
      </div>
    </div>

  </div>
</template>

<script>
import Modal from "@/components/Modal";
import BaseButton from "@/components/BaseButton";
import BaseInput from "@/components/BaseInput";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import { Card } from "@/components/Card";
import NameService from "../services/NameService";
import { ASelect, ASelectOption, AButton, Table, Pagination } from "ant-design-vue";
import NamePictureView from './NamePictureView.vue';


const namesColumns = [
  "nameId",
  "year",
  "date",
  "competitionId",
  "nameId"
]

export default {
  props: {
    names: {
      type: Array,
      required: true,
    },
    totalElements: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
  },
  components: {
    Card,
    Modal,
    BaseButton,
    BaseInput,
    Table,

    Pagination,
    NamePictureView
  },

  data() {
    return {
      modalNames: false,
        isTableView: true,

      columns: [
        {
          title: 'Name Id',
				dataIndex: 'nameId',
	          visible: true,
          scopedSlots: { customRender: 'nameId' },
          sorter: true
          //sorter: (a, b) => a.nameId - b.nameId,
          //sorter: (a, b) => a.nameId.localeCompare(b.nameId),
        },
        {
          title: 'Snake',
		dataIndex: 'snake',
          visible: true,
          scopedSlots: { customRender: 'snake' },
          sorter: true
          //sorter: (a, b) => a.snake - b.snake,
          //sorter: (a, b) => a.snake.localeCompare(b.snake),
        },
        {
          title: 'Snake Plural',
		dataIndex: 'snakePlural',
          visible: true,
          scopedSlots: { customRender: 'snakePlural' },
          sorter: true
          //sorter: (a, b) => a.snakePlural - b.snakePlural,
          //sorter: (a, b) => a.snakePlural.localeCompare(b.snakePlural),
        },
        {
          title: 'Camel',
		dataIndex: 'camel',
          visible: true,
          scopedSlots: { customRender: 'camel' },
          sorter: true
          //sorter: (a, b) => a.camel - b.camel,
          //sorter: (a, b) => a.camel.localeCompare(b.camel),
        },
        {
          title: 'Camel Plural',
		dataIndex: 'camelPlural',
          visible: true,
          scopedSlots: { customRender: 'camelPlural' },
          sorter: true
          //sorter: (a, b) => a.camelPlural - b.camelPlural,
          //sorter: (a, b) => a.camelPlural.localeCompare(b.camelPlural),
        },
        {
          title: 'Pascal',
		dataIndex: 'pascal',
          visible: true,
          scopedSlots: { customRender: 'pascal' },
          sorter: true
          //sorter: (a, b) => a.pascal - b.pascal,
          //sorter: (a, b) => a.pascal.localeCompare(b.pascal),
        },
        {
          title: 'Pascal Plural',
		dataIndex: 'pascalPlural',
          visible: true,
          scopedSlots: { customRender: 'pascalPlural' },
          sorter: true
          //sorter: (a, b) => a.pascalPlural - b.pascalPlural,
          //sorter: (a, b) => a.pascalPlural.localeCompare(b.pascalPlural),
        },
        {
          title: 'Snake Dash',
		dataIndex: 'snakeDash',
          visible: true,
          scopedSlots: { customRender: 'snakeDash' },
          sorter: true
          //sorter: (a, b) => a.snakeDash - b.snakeDash,
          //sorter: (a, b) => a.snakeDash.localeCompare(b.snakeDash),
        },
        {
          title: 'Display Label',
		dataIndex: 'displayLabel',
          visible: true,
          scopedSlots: { customRender: 'displayLabel' },
          sorter: true
          //sorter: (a, b) => a.displayLabel - b.displayLabel,
          //sorter: (a, b) => a.displayLabel.localeCompare(b.displayLabel),
        },
        {
          title: 'Display Label Plural',
		dataIndex: 'displayLabelPlural',
          visible: true,
          scopedSlots: { customRender: 'displayLabelPlural' },
          sorter: true
          //sorter: (a, b) => a.displayLabelPlural - b.displayLabelPlural,
          //sorter: (a, b) => a.displayLabelPlural.localeCompare(b.displayLabelPlural),
        },
        {
          title: 'Application Id',
		dataIndex: 'applicationId',
          visible: false,
          scopedSlots: { customRender: 'applicationId' },
          sorter: true
          //sorter: (a, b) => a.applicationId - b.applicationId,
          //sorter: (a, b) => a.applicationId.localeCompare(b.applicationId),
        },
        {
          title: 'Application Name',
		dataIndex: 'applicationName',
          visible: true,
          scopedSlots: { customRender: 'applicationName' },
          sorter: true
          //sorter: (a, b) => a.applicationName - b.applicationName,
          //sorter: (a, b) => a.applicationName.localeCompare(b.applicationName),
        },
      ],
      pagination: {
        current: 1,
        pageSize: 50,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `Total ${total} names`,
      },

      names: [],
      nameToAdd: {},

      namesTable: {
        columns: [...namesColumns],
        data: [],
      },

      // New properties for sorting and searching
      sortBy: 'nameId',           // Column to sort by
      sortOrder: 'asc',     // Sort order (asc or desc)
      searchQuery: '',      // Search query
      searchLoading: false, // Initialize searchLoading property


    };
  },
  watch: {
    searchQuery: {
      handler: "handleSearchQueryChanged", // Call the fetchData method when searchQuery changes
      immediate: true, // Trigger immediately when the component is mounted
    },
  },

  methods: {

    async renderNamesTable() {
      this.searchLoading = true; // Set searchLoading to true while fetching data
      this.searchLoading = false;

      this.pagination.total = this.totalElements;
      this.pagination.current = this.page;

      let namesTableData = [];
      for (let i = 0; i < this.names.length; i++) {
        namesTableData.push({
          id: i,
          nameId: this.names[i].nameId,
          year: this.names[i].year,
          date: this.names[i].date,
          competitionId: this.names[i].competitionId,
          nameId: this.names[i].nameId,
        });

      }
      this.searchLoading = false;
    },

    async onTableChange(pagination, filters, sorter) {
      if (sorter && sorter.field && sorter.order) {
        this.sortBy = sorter.field;
        if (sorter.order == "ascend") {
            this.sortOrder = "asc";
        } else {
            this.sortOrder = "desc";
        }
      }
      if (pagination) {
        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;
      }

	  this.$emit('get-all-names',this.sortBy,this.sortOrder,this.pagination.current-1,this.pagination.pageSize);
      this.handleTableChanged()
    },
	
	initializeColumns() {
        this.columns = this.columns.filter(item => item.visible);
    },

    routingToApplicationDetail(id) {
      this.$router.push({ name: 'ApplicationDetail', params: { applicationId: id.toString() }})
    },
    routingToDomainClassDetail(id) {
      this.$router.push({ name: 'DomainClassDetail', params: { domainClassId: id.toString() }})
    },
    routingToFieldDetail(id) {
      this.$router.push({ name: 'FieldDetail', params: { fieldId: id.toString() }})
    },
    routingToDetailViewTableDetail(id) {
      this.$router.push({ name: 'DetailViewTableDetail', params: { detailViewTableId: id.toString() }})
    },
    routingToMappedClassDetail(id) {
      this.$router.push({ name: 'MappedClassDetail', params: { mappedClassId: id.toString() }})
    },
    routingToNameDetail(id) {
      this.$router.push({ name: 'NameDetail', params: { nameId: id.toString() }})
    },
    routingToSubmenuDetail(id) {
      this.$router.push({ name: 'SubmenuDetail', params: { submenuId: id.toString() }})
    },
    routingToFieldTypeDetail(id) {
      this.$router.push({ name: 'FieldTypeDetail', params: { fieldTypeId: id.toString() }})
    },
    routingToUserDetail(id) {
      this.$router.push({ name: 'UserDetail', params: { userId: id.toString() }})
    },
    routingToRoleDetail(id) {
      this.$router.push({ name: 'RoleDetail', params: { roleId: id.toString() }})
    },
    routingToUserRoleDetail(id) {
      this.$router.push({ name: 'UserRoleDetail', params: { userRoleId: id.toString() }})
    },
    
    handleSearchQueryChanged() {
    	console.log("handleSearchQueryChanged CALLED FROM @search")
    	this.$root.$emit('searchQueryForNamesChanged', this.searchQuery);
		//this.renderNamesTable();
    },

    onSearch(value) {
      console.log(value);
      this.searchQuery = value; // Update searchQuery when the user types
    },

    toggleView() {
      this.isTableView = !this.isTableView;
    },
	
	async handleAddSubmitted() {
      this.modalNames = false;

      const currentDate = new Date().getTime();
      this.nameToAdd.created = currentDate;

      const jsonData = JSON.stringify(this.nameToAdd);
      console.log(jsonData);
      
      const res = await NameService.addName(jsonData);

      if (res.status === 200) {
        this.$notify({
          component: NotificationTemplate,
          icon: "tim-icons icon-bell-55",
          type: "success",
          timeout: 3000,
        });
      }
	},
	
	handleTableChanged() {
	},
	
	formatTime(dateString) {
      if(dateString !== null){
        const date = new Date(dateString);
      return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')} EST`;
      }
      // Format the date here as needed, for example:
    },  
    
 formatDate(dateString) {
    if (dateString !== null) {
	    const date = new Date(dateString);
	    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	    const day = String(date.getDate()).padStart(2, '0');
	    const monthAbbreviation = months[date.getMonth()];
	    const year = date.getFullYear();
	    return `${day} ${monthAbbreviation} ${year}`;
  	}
  	// Handle the case when dateString is null or invalid
  	return '';
    
   },

  },
  mounted() {
  	this.initializeColumns();
    this.renderNamesTable();
  }
};
</script>

<style>
.modal-dialog {
  margin-top: -300px;
}
.ant-table-row  {
	text-align: center;
}
.ant-table-thead th span {
	text-align: center;
	width: 100%
}
.ant-table-fixed td span {
    text-align: center;
}
.header-search {
  width: 300px !important;
  margin-left: auto !important;
}
</style>
